import type { PlanCustomMailSettingI18nInput } from "@/lib/gql/__generated__/graphql";

import type { ProductDayTripPlanI18nFormModel } from "../../../../type";

type Props = {
	viewModel: ProductDayTripPlanI18nFormModel["ViewModel"];
};

export const viewModelToPlanCustomMailSettingInputConverter = ({
	viewModel,
}: Props): PlanCustomMailSettingI18nInput => {
	const {
		hotelID,
		planID,
		atCreated,
		atUpdated,
		atCanceled,
		atCheckInBefore_00days,
		atCheckInBefore_01days,
		atCheckInBefore_07days,
		atCheckOutAfter_01days,
		lang,
	} = viewModel;

	return {
		id: hotelID,
		planID,
		lang,
		forReservation: {
			atCreated: {
				text: atCreated?.text?.value || "",
				override: atCreated?.override?.value || false,
			},
			atUpdated: {
				text: atUpdated?.text?.value || "",
				override: atUpdated?.override?.value || false,
			},
			atCanceled: {
				text: atCanceled?.text?.value || "",
				override: atCanceled?.override?.value || false,
			},
			atCheckInBefore_07days: {
				text: atCheckInBefore_07days?.text?.value || "",
				override: atCheckInBefore_07days?.override?.value || false,
				shouldSendEmail: atCheckInBefore_07days?.shouldSendEmail?.value || false,
			},
			atCheckInBefore_01days: {
				text: atCheckInBefore_01days?.text?.value || "",
				override: atCheckInBefore_01days?.override?.value || false,
				shouldSendEmail: atCheckInBefore_01days?.shouldSendEmail?.value || false,
			},
			atCheckInBefore_00days: {
				text: atCheckInBefore_00days?.text?.value || "",
				override: atCheckInBefore_00days?.override?.value || false,
				shouldSendEmail: atCheckInBefore_00days?.shouldSendEmail?.value || false,
			},
			atCheckOutAfter_01days: {
				text: atCheckOutAfter_01days?.text?.value || "",
				override: atCheckOutAfter_01days?.override?.value || false,
				shouldSendEmail: atCheckOutAfter_01days?.shouldSendEmail?.value || false,
			},
		},
	};
};
